export default function getWarehouseRules(configuration) {
  const { width, xWallSegmentWidth } = configuration;

  return {
    length: {
      default: xWallSegmentWidth === 4 ? 12 : 15,
      min: width,
      max: 200,
      step: xWallSegmentWidth,
    },
    width: {
      default: 15,
      min: 10,
      max: 30,
      step: 5,
    },
    height: {
      default: 5.2,
      min: 4.2,
      max: 7,
      values: [4.2, 5.2, 6.2, 7],
    },
  };
}
